function handleStickyBar() {
  const bannerHeight = $('.banner').outerHeight();

  $(window).on('scroll', function () {
    // Show sticky bar if user has scrolled past the hero
    if ($(this).scrollTop() > bannerHeight) {
      $('.banner').addClass('banner--sticky');
    } else {
      $('.banner').removeClass('banner--sticky');
    }
  });
}

export default function header() {
  $('.navbar-toggler').on('click', function () {
    $(this).toggleClass('navbar-toggler--menu-open');

    $('.banner').find('.btn').toggleClass('d-none');
    $('.banner').toggleClass('banner--menu-open');
  });

  handleStickyBar();

  $('.menu-item-has-children > .nav-link').on('click', function (event) {
    event.preventDefault();
    $(this).parents('.menu-item-has-children').toggleClass('menu-item-has-children--sub-menu-open');
  });
}



// WEBPACK FOOTER //
// ./scripts/components/header.js